const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: "100vh"
  },
  baseFont: {
    fontFamily: "FSElliotPro",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: 1.5
  },
  form: {
    margin: "0 16px"
  },
  label: {
    fontFamily: "FSElliotPro",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: 1.43,
    marginBottom: "8px"
  },
  inputField: {
    fontFamily: "FSElliotPro",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: 1.5,
    padding: "12px 16px 12px 0",
    borderColor: "rgba(51, 51, 51, 0.2)"
  },
  helper: {
    margin: "8px 0 0 0",
    fontFamily: "FSElliotPro",
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: 1.43,
    color: "#616367"
  },
  btnContainer: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "fixed",
    width: "100%",
    bottom: 0
  },
  btn: {
    display: "inline-block",
    position: "relative",
    width: "100%"
  },
  btnText: {
    fontFamily: "FSElliotPro",
    fontSize: "16px",
    fontWeight: "normal",
    color: "#0076CF",
    marginTop: "16px",
    padding: 0,
    textTransform: "capitalize",
    lineHeight: "20px"
  },
  prefix: {
    fontFamily: "FSElliotPro",
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: 1.5
  },
  RM: {
    paddingLeft: "16px"
  },
  alertTitle: {
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: 1.4,
    color: "#000"
  },
  errorAmountRsp: {
    margin: "4px 0 0 0",
    color: "error",
    fontFamily: "FSElliotPro",
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: 1.57
  },
  termCondition: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    margin: "24px 16px 16px"
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  dropdownTitle: {
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: 1.4
  }
};

export default styles;
